import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {

  constructor(private authService: AuthservicesService, private router: Router) { }

  ngOnInit(): void {
  }



  outputData(e) {
    
    this.router.navigate(['/fellowship-directory'], { queryParams: e});
  }

}
